// test975
(975 && 0);
